import React, { memo } from 'react'
import { ConfirmationModal, INLINE_MESSAGE_VARIANTS } from 'transfix-ui'

interface IDeleteRuleModalProps {
  disabled: boolean
  onClose: () => void
  onConfirm: () => void
  error: string | undefined
}

export const DeleteRuleModal = memo<IDeleteRuleModalProps>(
  ({ disabled, error, onClose, onConfirm }) => (
    <ConfirmationModal
      title='Delete Rule?'
      size={6}
      open
      error={error}
      inlineMessageProps={
        error
          ? {
              message: error,
              type: INLINE_MESSAGE_VARIANTS.ALERT,
            }
          : undefined
      }
      actions={[
        {
          label: 'No',
          type: 'dismiss',
          action: onClose,
        },
        {
          label: 'Yes',
          type: 'confirm',
          action: onConfirm,
          disabled,
        },
      ]}
      onClose={onClose}
      dataTest='delete-rule=modal'>
      Are you sure you want to delete this rule?
    </ConfirmationModal>
  )
)
